import { KeepAliveOutlet } from './RouteStack';
import { useTheme } from '../contexts/ThemeContext';
import { InboxProvider } from '../contexts/InboxContext';

/**
 * Wrapper for all protected routes
 * Provides KeepAliveOutlet for caching all authenticated routes
 * Used as parent for both MainScreen (with TopBar) and DetailLayout (without TopBar)
 *
 * `InboxProvider` is mounted HERE — ABOVE `KeepAliveOutlet` — so the single
 * `useInbox()` core renders EXACTLY ONCE per authenticated session and is NOT
 * duplicated. `KeepAliveOutlet` caches each matched outlet subtree per
 * `pathname+screenKey` and renders every cached entry simultaneously, so any
 * provider placed INSIDE a cached layout (e.g. `MainRouteContainer`) would be
 * instantiated once per cached main-nav route (`/` and `/inbox` are both
 * `persistCache: true`), reintroducing the inbox double-fetch and a second live
 * chat subscription. Mounting the provider above the cache keeps it a true
 * session singleton: one first-page fetch, one chat message-nodes subscription,
 * and a badge that stays live whether or not `/inbox` has been visited (finding 1).
 */
export const ProtectedRoutesWrapper = () => {
  const { theme } = useTheme();

  return (
    <div
      className="min-h-screen"
      style={{ backgroundColor: theme.background }}
    >
      {/* InboxProvider above the cache = ONE shared inbox core for the session */}
      <InboxProvider>
        {/* KeepAliveOutlet caches all child routes */}
        <KeepAliveOutlet />
      </InboxProvider>
    </div>
  );
};
